import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="bg-black py-32 border-t border-gray-900">
      <div className="max-w-[1600px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <p 
                className="text-sm uppercase tracking-[0.3em] mb-6"
                style={{
                  background: 'linear-gradient(90deg, #7A6A5A 0%, #C4B8A8 50%, #7A6A5A 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                About MACGOC
              </p>
              <h2 className="text-4xl lg:text-5xl font-light text-white mb-6 leading-tight">
                Enterprise Consulting Platform Operating Through U.S. Entities
              </h2>
            </div>

            <div className="space-y-6 text-base text-gray-400 leading-relaxed">
              <p>
                MACGOC is a strategic consulting platform envisioned to deliver enterprise-grade advisory services across technology, healthcare, logistics, fuel retail, and finance. We operate through established U.S.-registered entities to serve healthcare systems, logistics operators, fuel retailers, investors, and government-adjacent clients nationwide.
              </p>
              <p>
                Our operations are conducted through <strong className="text-white">MACAR Enterprises Corp.</strong>, the North American division of MACGOC, and <strong className="text-white">North American Healthcare Group Corp.</strong>, our specialized healthcare consulting division.
              </p>
              <p>
                With leadership based in the United States and decades of combined experience across engineering, healthcare administration, finance, and international business development, MACGOC provides the strategic insight and operational expertise enterprises need to optimize performance, navigate complexity, and achieve sustainable growth.
              </p>
            </div>

            <div className="pt-4">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 text-white px-10 py-4 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
                style={{
                  background: 'linear-gradient(135deg, #7A6A5A 0%, #A89078 50%, #C4B8A8 100%)',
                }}
              >
                Learn More About MACGOC
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative h-[600px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fa84e91b055968b5a6d75f4970a7c78d.jpg"
                alt="MACGOC Operations"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              
              {/* Operating Entities */}
              <div className="absolute bottom-0 left-0 right-0 p-10 space-y-4">
                <div className="bg-black/70 backdrop-blur-sm rounded-xl p-6 border border-copper/20">
                  <p className="text-xs uppercase tracking-widest text-copper-light mb-2">North American Division</p>
                  <p className="text-white font-semibold text-lg">MACAR Enterprises Corp.</p>
                  <p className="text-gray-400 text-sm">U.S.-Registered Operating Entity</p>
                </div>
                <div className="bg-black/70 backdrop-blur-sm rounded-xl p-6 border border-copper/20">
                  <p className="text-xs uppercase tracking-widest text-copper-light mb-2">Healthcare Division</p>
                  <p className="text-white font-semibold text-lg">North American Healthcare Group Corp.</p>
                  <p className="text-gray-400 text-sm">Specialized Healthcare Consulting</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
